import styled from 'styled-components';

import { TemplateProfileImage } from '@xing-com/crate-lebenslauf-components';
import { type HeaderFontSize } from '@xing-com/crate-lebenslauf-helpers';
import { spaceL } from '@xing-com/tokens';

export const Container = styled.div`
  display: flex;
`;

export const Name = styled.div<{ $hasImage?: boolean }>`
  width: 100%;
  position: absolute;
  top: 25px;
  left: ${({ $hasImage }) => ($hasImage ? '170px' : '41px')};
  flex: 1;
`;

export const NameField = styled.div<HeaderFontSize>`
  font-size: ${(props) => props.$fontSize}px;
  line-height: ${(props) => props.$fontSize + 14}px;
  font-family: 'Open Sans';
  font-weight: 700;
  color: var(--mainColor);
`;

export const Tag = styled.div`
  position: absolute;
  right: 0;
  top: 40px;
  width: 154px;
  height: 35px;
  background: var(--mainColor);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: var(--pageMarginRight);
  padding-left: 10px;
  color: #fff;
  font-family: 'Open Sans';
  font-size: 16px;
`;

export const ProfileImage = styled(TemplateProfileImage)`
  position: absolute;
  top: 23px;
  left: 41px;
`;

export const PersonalData = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0 12px;
  margin-top: ${spaceL};
`;

export const Item = styled.div`
  min-width: 31%;
`;
